import React from "react";
import { Row, Col } from "react-bootstrap";
import Footer from "./Footer";
import NavbarWithDrawer from "./NavbarWithDrawer";

const ChildSafety = () => {
  return (
    <>
      {localStorage.getItem("x-auth-token") && <NavbarWithDrawer />}
      <div className={`container-fluid ${localStorage.getItem("x-auth-token") ? "mt-5" : ""}`}>
        <div className="p-5 mbl-pedding-10">
          <Row className="mt-2">
            <Col md={12} className="page-main">
              <h1 className="mb-4">Child Safety Standards</h1>

              <h5 className="mt-4">1. Introduction</h5>
              <p>
                {process.env.REACT_APP_SITE_NAME} is a secure and private messaging platform designed for structured
                communication between users and group leaders. We are committed to ensuring a safe
                environment for all users, especially children, and we strictly follow child safety
                standards.
              </p>

              <h5 className="mt-4">2. Zero Tolerance Policy</h5>
              <p>{process.env.REACT_APP_SITE_NAME} has a zero-tolerance policy against Child Sexual Abuse and Exploitation (CSAE).</p>
              <ul>
                <li>Any form of child sexual abuse material (CSAM) is strictly prohibited</li>
                <li>Any attempt to exploit or harm minors will result in immediate action</li>
                <li>Accounts involved in such activities will be permanently banned</li>
              </ul>

              <h5 className="mt-4">3. Prohibited Content</h5>
              <p>The following content is strictly not allowed on {process.env.REACT_APP_SITE_NAME}:</p>
              <ul>
                <li>Child Sexual Abuse Material (CSAM)</li>
                <li>Any sexual or inappropriate content involving minors</li>
                <li>Grooming, harassment, or exploitation of children</li>
                <li>Sharing or promoting harmful content related to minors</li>
              </ul>

              <h5 className="mt-4">4. Reporting and Safety Measures</h5>
              <p>
                We provide users with the ability to report harmful or inappropriate content. Users
                can report issues by:
              </p>
              <ul>
                <li>Using the in-app reporting feature</li>
                <li>
                  Contacting us via email at{" "}
                  <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</a>
                </li>
              </ul>
              <p>All reports are reviewed promptly, and appropriate action is taken.</p>

              <h5 className="mt-4">5. Enforcement Actions</h5>
              <p>
                If any user violates our child safety policies, we may take the following actions:
              </p>
              <ul>
                <li>Remove the content immediately</li>
                <li>Suspend or permanently ban the account</li>
                <li>Report the activity to relevant law enforcement authorities if required</li>
              </ul>

              <h5 className="mt-4">6. Compliance with Laws</h5>
              <p>
                {process.env.REACT_APP_SITE_NAME} complies with all applicable child safety laws and regulations. We cooperate
                fully with law enforcement agencies in cases involving child safety violations.
              </p>

              <h5 className="mt-4">7. Child Safety Contact</h5>
              <p>If you have any concerns related to child safety, please contact us:</p>
              <ul>
                <li>
                  Email:{" "}
                  <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</a>
                </li>
                <li>Phone: {process.env.REACT_APP_SUPPORT_PHONE}</li>
              </ul>

              <h5 className="mt-4">8. Updates to This Policy</h5>
              <p>
                We may update this policy from time to time to ensure continued compliance with
                safety standards and legal requirements.
              </p>
            </Col>
          </Row>
        </div>
      </div>
      {localStorage.getItem("x-auth-token") && <Footer />}
    </>
  );
};

export default ChildSafety;
